import { css } from '@emotion/css';

export const sectionWrapper = (params) => css`
  display: flex;
  color: ${params?.textColor};
  flex-direction: column;
  ${params?.isMobile ? `
    width: 100%;
  ` : `
    width: ${params?.fitWidth ? 'fit-content' : '100%'};
  `}
`;

export const containerWrapper = css`
  margin: 0;
  background: transparent;
  position: relative;
  font-family: inherit;
  border-radius: 5px;
  margin: 5px 0;
  font-size: 15px;
`;

export const standaloneWrapper = (params) => css`
  padding: ${params?.isMobile
    ? '5px 0;'
    : '10px 150px;'
  // eslint-disable-next-line indent
  }
  background-color: darkgrey;
  background-image: linear-gradient( 45deg, grey 25%, transparent 25%, transparent 75%, grey 75%, grey ),
    linear-gradient(45deg,grey 25%,transparent 25%,transparent 75%,grey 75%,grey);
  background-size: 16px 16px;
  background-position: 0 0,8px 8px;
  position: relative;
  font-family: sans-serif;
  border-radius: 5px;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  position: absolute;
  font-size: 15px;
  & > div {
    box-sizing: border-box;
  }
  ul {
    list-style: none;
    padding: 0;
  }
  li {
    display: list-item;
    text-align: -webkit-match-parent;
  }
  input {
    box-sizing: border-box;
  }
`;
